<template>
  <v-snackbar
    bottom
    color="blue-grey"
    :timeout="snackbar.time"
    v-model="snackbar.open"
    shaped
  >
    <font size="4px" style="font-weight: bold;" class="white--text">{{
      snackbar.text
    }}</font>

    <template v-slot:action="{ attrs }">
      <v-btn
        @click="snackbar.open = false"
        color="white--text"
        text
        v-bind="attrs"
      >
        CLOSE
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "SnackBar",
  computed: {
    snackbar() {
      return this.$store.state.common.snackbar;
    },
  },
};
</script>

<style scoped></style>
